/**
 * Guía: Puntos y Cashback.
 *
 * Contenido derivado del capítulo **34b** del manual: §0 (las dos palancas,
 * a quién aplican y la precedencia entre campaña y configuración fija).
 *
 * El primer paso es el aviso: ninguna de las dos palancas se aplica a un
 * cliente o a un comercio concreto. Un multiplicador puesto por error
 * duplica el pasivo de puntos de un mercado entero hasta que alguien lo
 * note.
 */

import type { TourFlow } from '../types';

const PUNTOS_PATH = '/points-cashback';

export const c34bPuntosYCashback: TourFlow = {
  id: 'admin.points-cashback',
  chapter: '34b',
  title: 'Puntos y cashback',
  summary:
    'Dos palancas que aplican a todo el país a la vez, y cuál manda cuando hay campaña.',
  href: PUNTOS_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Esto aplica a todo el país, todo el rato',
      body:
        'Ni a un cliente, ni a un comercio, ni a una campaña concreta: a todos los clientes ' +
        'del país seleccionado. Un multiplicador puesto por error duplica el pasivo de ' +
        'puntos de un mercado entero hasta que alguien lo vea.',
      route: PUNTOS_PATH,
    },
    {
      id: 'two-levers',
      title: 'Puntos y cashback son cosas distintas',
      body:
        'El multiplicador decide cuántos puntos gana un cliente comprando: los puntos son ' +
        'un pasivo, se otorgan gratis y se canjean contra pedidos reales. El cashback de ' +
        'recargas es dinero que pone la plataforma encima de lo que el cliente recarga.',
      target: 'admin.pointsCashback.tabs',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'precedence',
      title: 'Una campaña pisa a la configuración fija',
      body:
        'Cada palanca tiene una configuración siempre vigente y campañas de calendario que ' +
        'mandan durante su ventana. Si un valor no es el que esperabas, mira primero si hay ' +
        'una campaña activa: es ella la que está decidiendo.',
    },
    {
      id: 'check-before-quoting',
      title: 'Estos valores se consultan, no se recuerdan',
      body:
        'Todo lo que el manual cita sobre puntos son valores por defecto. Antes de decirle ' +
        'a alguien cuántos puntos gana o cuánto cashback recibe, se mira aquí — y se ' +
        'comprueba si hay campaña.',
    },
  ],
};
